import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './App.css';
import { Page } from './Page';
import Goto from './screens/Goto/Goto';
import HomePage from './screens/HomePage/HomePage';
export default class App extends React.PureComponent {
  render() {
    return (
      <div className={`App`}>
        <BrowserRouter>
          <div>
            <Switch>
              <Route
                path={Page.homepage}
                exact
                render={() => <HomePage />}
              />
              <Route
                path={Page.goto}
                render={() => <Goto />}
              />
            </Switch>
          </div>
        </BrowserRouter>
      </div>
    );
  }
}
